;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingFromGuide = Marionette.ItemView.extend({
		className: '',
		template: JST.TippingFormGuide,
		data: {},
		initialize: function() {
			this.formGuide = this.getOption('formGuide');
			this.match_id  = this.getOption('match_id');
			this.home_odds = this.getOption('home_odds');
			this.away_odds = this.getOption('away_odds');
			this.hide_odds = this.getOption('hide_odds');
			this.show_form = false;

			if (typeof this.hide_odds == 'undefined') {
				this.hide_odds = false;
			}
		},

		ui: {
			"form_guide_open": '.js-form-guide-open'
		},

		events: {
			"click @ui.form_guide_open": 'openFormGuide'
		},

		setTemplateData: function(obj) {
			//_.extend(this.data, obj);

			this.model = new Backbone.Model(obj || {});
			this.model.set({
				show_form: this.show_form,
				home_odds: this.home_odds,
				away_odds: this.away_odds,
				show_odds: !this.hide_odds,
				img_url:   CONFIG.IMAGES_URL
			});
			this.render();
			return this;
		},

		openFormGuide: function(e) {
			if (!this.show_form) {
				this.loadFormGuideData();
			}
			else {
				this.show_form = false;
				this.setTemplateData({
					test: this.test
				});
			}
		},

		loadFormGuideData: function() {

			$.when.call(null, this.formGuide.loadData(this.match_id).fetch({
				is_project_json: true,
				data:{
					match_id: this.match_id
				}
			})).done(_.bind(function(model, response) {
				this.show_form = true;
				this.prepareData(model);
			}, this));

			return this;
		},

		prepareData: function(data) {

			if(data.trend) {
				data.trend.home = data.trend[data.home_squad_id];
				data.trend.away = data.trend[data.away_squad_id];
			}

			if (data.last_5) {
				data.recent_home = data.last_5[data.home_squad_id];
				data.recent_away = data.last_5[data.away_squad_id];
			}

			if (data.head_to_head) {

				data.hth = {};
				data.hth.home = data.head_to_head[data.home_squad_id];
				data.hth.away = data.head_to_head[data.away_squad_id];

				data.hth.home.wins_percent = Math.round(data.hth.home.wins / (data.hth.home.wins + data.hth.away.wins) *100 );
				data.hth.away.wins_percent = Math.round(data.hth.away.wins / (data.hth.home.wins + data.hth.away.wins) *100 );

				if(data.hth.home.wins == 0 &&  data.hth.away.wins == 0) {
					data.hth.home.wins_percent = 0;
					data.hth.away.wins_percent = 0;
				}

				data.hth.home.season_wins_pct_percent = Math.round(data.hth.home.season_wins_pct / (data.hth.home.season_wins_pct + data.hth.away.season_wins_pct) *100 );


			}

			this.setTemplateData(data);

			return this;
		}

	});

}(window, APP, Backbone, Marionette, $, _));